export const ENTITY_TAG_NAMESPACE = 'entity'

export type EntityTagValue = 'contact' | 'meeting' | 'ccq' | 'document' | 'insights'

export const ENTITY_TAG_VALUES: readonly EntityTagValue[] = ['contact', 'meeting', 'ccq', 'document', 'insights']

export interface EntityTagInfo {
  chipLabel: string
  runFrom: string
  icon: string
}

export const ENTITY_TAGS: Record<EntityTagValue, EntityTagInfo> = {
  contact: { chipLabel: 'Contacts', runFrom: 'a contact page', icon: 'bi-person-lines-fill' },
  meeting: { chipLabel: 'Meetings', runFrom: 'a meeting', icon: 'bi-calendar4-week' },
  ccq: { chipLabel: 'Client Queries', runFrom: 'Client Queries results', icon: 'bi-x-diamond' },
  document: { chipLabel: 'Documents', runFrom: 'a document', icon: 'bi-file-earmark-richtext' },
  insights: { chipLabel: 'Insights', runFrom: 'the Insights page', icon: 'bi-lightbulb' },
}

const isEntityTagValue = (value: string): value is EntityTagValue => ENTITY_TAG_VALUES.some((known) => known === value)

export const entityTag = (value: EntityTagValue): string => `${ENTITY_TAG_NAMESPACE}:${value}`

export const parseEntityTag = (tag: string): EntityTagValue | null => {
  const [namespace, value, ...rest] = tag.toLowerCase().split(':')
  if (namespace !== ENTITY_TAG_NAMESPACE || value === undefined || rest.length > 0) {
    return null
  }
  return isEntityTagValue(value) ? value : null
}

export const entityTagsOf = (workflow: { tags: string[] }): EntityTagValue[] => {
  const present = new Set(workflow.tags.map(parseEntityTag))
  return ENTITY_TAG_VALUES.filter((value) => present.has(value))
}
